import React from 'react';
import c from '../w.js';

const IconArrowsHorizontal = React.memo(
  c(
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M14 8.99983L6.41421 8.99983L9.70711 12.2927L8.2929 13.7069L2.58579 7.99983L8.29289 2.29272L9.70711 3.70694L6.41421 6.99983L14 6.99983V8.99983Z" }), /* @__PURE__ */ React.createElement("path", { d: "M10 17H17.5858L14.2929 20.2929L15.7071 21.7071L21.4142 16L15.7071 10.2929L14.2929 11.7071L17.5858 15H10L10 17Z" }))
  )
);

export { IconArrowsHorizontal };
